import { useState } from 'react'
import { SvgIcon, SvgIconType } from '@integration-app/react'
import clsx from 'clsx'

import { Menu } from 'components/Menu'

import classes from './FieldTypeSelector.module.css'
import { useSchemaBuilderContext } from '../../SchemaBuilder/SchemaContext'

const VALUE_TYPE_LABEL = {
  string: 'string',
  number: 'number',
  integer: 'integer',
  boolean: 'boolean',
  object: 'object',
  array: 'list',
  null: 'any',
  undefined: 'any',
}

export function FieldTypeSelector({
  type,
  onTypeChange,
}: {
  type: string
  onTypeChange?: (type: string) => void
}) {
  const { readOnly } = useSchemaBuilderContext()
  const [typeValue, setValue] = useState(type)

  if (!onTypeChange || readOnly) {
    return (
      <span
        className={clsx(
          classes.fieldType,
          classes[`fieldType__${typeValue}`],
          classes.readOnly,
        )}
      >
        {VALUE_TYPE_LABEL[typeValue]}
      </span>
    )
  }

  const valueTypes = [
    'string',
    'number',
    'integer',
    'boolean',
    'object',
    'array',
  ]

  function handleSelect({ value }: { value: string }) {
    setValue(value)
    onTypeChange?.(value)
  }

  return (
    <Menu.Root onSelect={handleSelect}>
      <Menu.Trigger
        className={clsx(classes.fieldType, classes[`fieldType__${typeValue}`])}
      >
        {VALUE_TYPE_LABEL[typeValue]} <SvgIcon type={SvgIconType.ChevronDown} />
      </Menu.Trigger>
      <Menu.Content>
        {valueTypes.map((type) => (
          <Menu.Item
            key={type}
            value={type}
            data-highlighted={type === typeValue ? 'true' : undefined}
            disabled={type === typeValue}
            icon={<SvgIcon type={SvgIconType[`SchemaType_${type}`]} />}
          >
            {VALUE_TYPE_LABEL[type]}
          </Menu.Item>
        ))}
      </Menu.Content>
    </Menu.Root>
  )
}
